import classnames from 'classnames'
import * as React from 'react'

import { TableAlign } from './types'

export interface TableCellProps extends React.HTMLProps<HTMLTableCellElement> {
  isFirst?: boolean
  isLast?: boolean
  align?: TableAlign
  hasPadding?: boolean
  hasLeading?: boolean
}

export function TableCell({
  isFirst,
  isLast,
  align = TableAlign.Left,
  hasPadding = true,
  hasLeading = true,
  className,
  ...props
}: React.PropsWithChildren<TableCellProps>) {
  return (
    <td
      {...props}
      className={classnames(className, {
        'is-first-cell': isFirst,
        'is-last-cell': isLast,
        'px-1': hasPadding,
        'p-0': !hasPadding,
        'leading-tight': hasLeading,
        'text-center': align === TableAlign.Center,
        'text-right': align === TableAlign.Right,
      })}
    />
  )
}
